import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

const { colors, spacing } = THEME;

export const styleSheet = StyleSheet.create({
	addTag: {
		position: 'relative',
		width: 460,
		gap: spacing.md,
	},
	addTagFooter: {
		alignItems: 'center',
		display: 'flex',
	},
	addTagFooterAddButton: {
		width: 90,
	},
	addTagFooterErrorMessage: {
		color: colors.danger.dark,
		fontSize: 14,
		letterSpacing: 0,
		marginLeft: '0.5rem',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		width: 'calc(100% - 100px)',
	},
	addTagHeader: {
		justifyContent: 'flex-end',
	},
	addTagTextInput: {
		width: '100%',
	},
	addTagTitle: {
		color: colors.primary.main,
		fontSize: 18,
		lineHeight: '22px',
	},
	inputRow: {
		gap: spacing.md,
	},
	lockRow: {
		alignItems: 'center',
		gap: spacing.sm,
	},
	lockLabel: {
		alignItems: 'center',
		cursor: 'pointer',
		display: 'inline-flex',
		fontSize: 14,
		gap: spacing.sm,
		userSelect: 'none',
	},
	lockInfoIcon: {
		alignItems: 'center',
		color: colors.icon.gray,
		cursor: 'help',
		display: 'inline-flex',
	},
	lockTooltipContent: {
		maxWidth: 320,
		lineHeight: 1.4,
	},
});
